import { render, staticRenderFns } from "./UserMessage.vue?vue&type=template&id=41901033&"
import script from "./UserMessage.vue?vue&type=script&lang=js&"
export * from "./UserMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports